import React, { useEffect } from "react";
import "./styles.css";
import Select from "../../Inputs/Select";
import {
  CashSaleReason,
  PropertySaleReasonOptions,
  PropertyTimeframeOptions,
} from "../../../Leadform/options";
import RadioList from "../../Inputs/RadioList";

const AboutSaleStep = ({
  title,
  description,
}: {
  title: string;
  description: string;
}) => {
  return (
    <div className="Step AboutSaleStep">
      <h2>{title}</h2>
      <p>{description}</p>

      <div className="PropertySummary">
        <RadioList
          label="What is your main reason for considering a cash sale?"
          inline={true}
          options={CashSaleReason}
          statekey="cash_sale_reason"
        />

        <Select
          label="What is your reason for selling?"
          inline={true}
          options={PropertySaleReasonOptions}
          statekey="sale_reason"
        />
      </div>

      <p>
        <b>
          Cash buyers purchase properties below full market value in exchange
          for a faster, more certain sale.
        </b>
      </p>

      <p>To receive cash buyer offers you must confirm this</p>

      <div className="acceptance">
        <RadioList
          label="Yes, I understand and can accept a below-market offer"
          inline={true}
          reverse={true}
          options={[{ label: "", value: "accept" }]}
          statekey="cash_sale_understanding"
        />
      </div>
    </div>
  );
};

export default AboutSaleStep;
